module.exports = __webpack_public_path__ + "static/media/asset-icon-active.e6b71219.svg";